import type { GlobalSearchResultItem } from 'models';
import { can } from 'old/utils/permissions';
import { useTranslation } from 'react-i18next';

import { Avatar } from 'ui';
import { images } from 'common/utils';
import { SearchItemContent } from '../search-item-content';
import { SearchItemRow } from '../search-item-row';

type P = {
  itemActionProps?: Record<string, unknown>;
  itemProps: GlobalSearchResultItem;
};

const CommunityItem = ({ itemActionProps, itemProps }: P) => {
  const { t } = useTranslation();

  return (
    <SearchItemRow
      icon={
        <Avatar
          alt={itemProps.name}
          fallbackPhoto={images.default.communityCoverPhoto}
          size="lg"
          src={itemProps.coverPhoto}
        />
      }
      itemActionProps={itemActionProps}
    >
      <SearchItemContent
        subtitle={`${itemProps.organization?.name ?? ''} • ${can(itemProps, 'Community', 'joined') ? t('Joined') : t('Not Joined')}`}
        title={itemProps.name ?? ''}
      />
    </SearchItemRow>
  );
};

export default CommunityItem;
